/**
 * Tiny ws-lifecycle event bridge: `client.ts` reports graphql-ws connection
 * events here; feature code (messaging live delivery) subscribes without the
 * apollo client module having to know about feature modules.
 *
 * Only RE-connections are emitted — events missed while the socket was down
 * are gone (the broker has no replay), so subscribers reconcile from the
 * history API on this signal (the DB is truth).
 */

type Listener = () => void

const listeners = new Set<Listener>()
let hasConnectedOnce = false

/** Called by the ws client on every successful connect (incl. the first). */
export function reportWsConnected(): void {
  if (!hasConnectedOnce) {
    hasConnectedOnce = true
    return
  }

  listeners.forEach((listener) => listener())
}

/** Subscribe to RE-connections (not the initial connect). */
export function onWsReconnect(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
